import { jsx } from "panel";
import { DateRangePickerEl } from "common/widgets/date-range-picker-new";
import { TrackingUsageContext } from "common/report/tracking-setup";
export function template() {
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-time-menu"
  }, this.attr(`open`) && /* @__PURE__ */ jsx(DateRangePickerEl, {
    attrs: {
      elref: `dateRangePicker`,
      "display-context": this.attr(`display-context`),
      "date-range": JSON.stringify(this.helpers.getDateRangeAttributes()),
      "project-as-of-date": this.attr(`project-as-of-date`),
      "max-history-days": this.attr(`max-data-history-days`),
      "tracked-use-case": TrackingUsageContext.QueryBuilder,
      "force-hide-preset-menu": true
    },
    on: {
      apply: this.helpers.onDateApply,
      cancel: this.helpers.onDateCancel
    }
  }));
}
